/* OG cart drawer: countdown note and one-tap Add for the "Make it a gift" row.
   The drawer's inner HTML is replaced on every cart change, so nothing here
   holds on to elements: the countdown looks the note up on each tick and the
   Add handler is delegated from the document. */
(function () {
  var TIMER_KEY = 'og_cart_timer_expiry';

  function readExpiry() {
    try {
      return parseInt(window.localStorage.getItem(TIMER_KEY), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function writeExpiry(value) {
    try {
      if (value) window.localStorage.setItem(TIMER_KEY, String(value));
      else window.localStorage.removeItem(TIMER_KEY);
    } catch (e) {}
  }

  function onCartPage() {
    return !!document.getElementById('main-cart-items');
  }

  function tick() {
    var drawer = document.querySelector('cart-drawer');
    var notes = document.querySelectorAll('[data-og-timer]');
    for (var n = 0; n < notes.length; n++) tickNote(notes[n], drawer);
    if (!notes.length && drawer && drawer.classList.contains('is-empty') && !onCartPage()) writeExpiry(0);
  }

  function tickNote(note, drawer) {

    var minutes = parseInt(note.getAttribute('data-minutes'), 10) || 10;
    var expiry = readExpiry();
    if (!expiry) {
      expiry = Date.now() + minutes * 60 * 1000;
      writeExpiry(expiry);
    }

    var left = Math.floor((expiry - Date.now()) / 1000);
    if (left <= 0) {
      // Countdown finished: swap in the "still here" message, or hide the note if none is set.
      var expiredText = note.getAttribute('data-expired-text');
      if (expiredText) {
        if (note.textContent !== expiredText) note.textContent = expiredText;
        note.hidden = false;
      } else {
        note.hidden = true;
      }
      return;
    }

    var value = note.querySelector('[data-og-timer-value]');
    if (value) {
      var m = Math.floor(left / 60);
      var s = left % 60;
      value.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    note.hidden = false;
  }

  tick();
  window.setInterval(tick, 1000);

  /* Confetti: one short burst each time the cart goes from fewer than 4 offer pieces to 4 or
     more while the drawer is open. Dropping below 4 and coming back up bursts once more;
     staying at 4 or above (reopening the drawer, adding a 5th piece) never replays it.
     Only runs when the tracker carries data-og-confetti (Theme settings > OG cart drawer). */
  var COUNT_KEY = 'og_cart_eligible';
  var CONFETTI_COLORS = ['#f2b705', '#ffd95a', '#ff8fab', '#ff6b6b', '#3ec6c6', '#ffffff', '#b5651d'];

  function readCount() {
    try {
      var stored = window.sessionStorage.getItem(COUNT_KEY);
      return stored === null ? null : parseInt(stored, 10) || 0;
    } catch (e) {
      return null;
    }
  }

  function writeCount(value) {
    try {
      window.sessionStorage.setItem(COUNT_KEY, String(value));
    } catch (e) {}
  }

  function burst(origin) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.querySelector('[data-og-confetti-canvas]')) return;

    var canvas = document.createElement('canvas');
    var ratio = Math.min(window.devicePixelRatio || 1, 2);
    var width = window.innerWidth;
    var height = window.innerHeight;
    canvas.setAttribute('data-og-confetti-canvas', '');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483646;';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    ctx.scale(ratio, ratio);

    var pieces = [];
    for (var i = 0; i < 120; i++) {
      var angle = -Math.PI / 2 + (Math.random() - 0.5) * 2.6;
      var speed = 6 + Math.random() * 10;
      pieces.push({
        x: origin.x + (Math.random() - 0.5) * 40,
        y: origin.y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        size: 6 + Math.random() * 6,
        spin: Math.random() * Math.PI,
        spinSpeed: (Math.random() - 0.5) * 0.4,
        color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
        round: i % 4 === 0,
      });
    }

    var start = null;
    var DURATION = 2200;

    function frame(now) {
      if (start === null) start = now;
      var elapsed = now - start;
      ctx.clearRect(0, 0, width, height);
      ctx.globalAlpha = elapsed > DURATION - 500 ? Math.max(0, (DURATION - elapsed) / 500) : 1;

      for (var j = 0; j < pieces.length; j++) {
        var piece = pieces[j];
        piece.vy += 0.28;
        piece.vx *= 0.985;
        piece.x += piece.vx;
        piece.y += piece.vy;
        piece.spin += piece.spinSpeed;
        ctx.save();
        ctx.translate(piece.x, piece.y);
        ctx.rotate(piece.spin);
        ctx.fillStyle = piece.color;
        if (piece.round) {
          ctx.beginPath();
          ctx.arc(0, 0, piece.size / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-piece.size / 2, -piece.size / 4, piece.size, piece.size / 2);
        }
        ctx.restore();
      }

      if (elapsed < DURATION) window.requestAnimationFrame(frame);
      else canvas.remove();
    }

    window.requestAnimationFrame(frame);
  }

  // A reading has to hold steady before it is trusted, so a drawer that is mid-refresh, or
  // anything else that makes the count flicker, cannot set off burst after burst:
  // "4 or more" must be seen twice in a row, "fewer than 4" for about two seconds.
  var memoryCount = null;
  var pendingCount = null;
  var pendingTicks = 0;

  function checkOffer() {
    // On the cart page the page's own tracker is watched; everywhere else, the drawer's.
    var page = onCartPage() ? document.querySelector('cart-items') : null;
    var drawer = document.querySelector('cart-drawer');
    var container = page || drawer;
    if (!container) return;

    // No tracker means no offer pieces (an empty cart).
    var offer = container.querySelector('[data-og-offer]');
    var count = offer ? parseInt(offer.getAttribute('data-eligible'), 10) || 0 : 0;

    if (count !== pendingCount) {
      pendingCount = count;
      pendingTicks = 1;
      return;
    }
    pendingTicks += 1;
    if (pendingTicks < (count >= 4 ? 2 : 7)) return;

    // Hold a completed offer until the drawer is open, so the burst is seen.
    if (count >= 4 && !page && !drawer.classList.contains('active')) return;

    var last = memoryCount !== null ? memoryCount : readCount();
    // Landing on the cart page with the offer already complete still earns one burst.
    if (last === null && page) last = 0;
    memoryCount = count;
    writeCount(count);

    if (last === null || last >= 4 || count < 4) return;
    if (!offer.hasAttribute('data-og-confetti')) return;

    var box = offer.getBoundingClientRect();
    burst({ x: box.left + box.width / 2, y: box.top + box.height / 2 });
  }

  window.setInterval(checkOffer, 300);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest('form[data-og-add]') : null;
    if (!form) return;
    if (form.closest('cart-items')) return; // cart page: a normal post reloads the cart

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; // fall back to a normal post

    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    var errorBox = document.querySelector('[data-og-add-error]');
    if (button) button.setAttribute('aria-busy', 'true');
    if (errorBox) errorBox.hidden = true;

    var body = new FormData(form);
    body.append(
      'sections',
      drawer
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',')
    );
    body.append('sections_url', window.location.pathname);

    var url = (window.routes && window.routes.cart_add_url) || form.getAttribute('action');

    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) {
          if (errorBox) {
            errorBox.textContent = state.description || state.message || '';
            errorBox.hidden = false;
          }
          if (button) button.removeAttribute('aria-busy');
          return;
        }
        drawer.renderContents(state);
      })
      .catch(function () {
        form.submit();
      });
  });
})();
